import React, {ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import {
	Annotation, Markup,
	MetadataRectangle,
	TextAnnotationIcons,
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {HelpIcon} from "../../../../shared/annotation/icon/HelpIcon";
import {InsertIcon} from "../../../../shared/annotation/icon/InsertIcon";
import {KeyIcon} from "../../../../shared/annotation/icon/KeyIcon";
import {NewParagraphIcon} from "../../../../shared/annotation/icon/NewParagraphIcon";
import {ParagraphIcon} from "../../../../shared/annotation/icon/ParagraphIcon";
import {NoteIcon} from "../../../../shared/annotation/icon/NoteIcon";
import {CommentIcon} from "../../../../shared/annotation/icon/CommentIcon";
import {CheckIcon} from "../../../../shared/annotation/icon/CheckIcon";
import {CircleIcon} from "../../../../shared/annotation/icon/CircleIcon";
import {StarIcon} from "../../../../shared/annotation/icon/StarIcon";
import {CrossIcon} from "../../../../shared/annotation/icon/CrossIcon";
import {CrossHairIcon} from "../../../../shared/annotation/icon/CrossHairIcon";
import {RightArrowIcon} from "../../../../shared/annotation/icon/RightArrowIcon";
import {RightPointerIcon} from "../../../../shared/annotation/icon/RightPointerIcon";
import {UpArrowIcon} from "../../../../shared/annotation/icon/UpArrowIcon";
import {UpLeftArrowIcon} from "../../../../shared/annotation/icon/UpLeftArrowIcon";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class TextAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	private renderIcon(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;
		let width: number = FunctionHelper.applyValue(rectBoundaries.width, 20);
		let height: number = FunctionHelper.applyValue(rectBoundaries.height, 20);

		let icon: TextAnnotationIcons = TextAnnotationIcons.Comment;
		for (let value of Object.values(TextAnnotationIcons)) {
			if (annotation.iconName?.toLowerCase() === value.toLowerCase()) {
				icon = value as TextAnnotationIcons;
				break;
			}
		}

		switch (icon) {
			case TextAnnotationIcons.Help:
				return (
					<HelpIcon width={width} height={height} language={this.props.language} opacity={opacity}
							  color={color}/>
				)
			case TextAnnotationIcons.Insert:
				return (
					<InsertIcon width={width} height={height} language={this.props.language} opacity={opacity}
								color={color}/>
				);
			case TextAnnotationIcons.Key:
				return (
					<KeyIcon width={width} height={height} language={this.props.language} opacity={opacity}
							 color={color}/>
				);
			case TextAnnotationIcons.NewParagraph:
				return (
					<NewParagraphIcon width={width} height={height} language={this.props.language} opacity={opacity}
									  color={color}/>
				);
			case TextAnnotationIcons.Paragraph:
				return (
					<ParagraphIcon width={width} height={height} language={this.props.language} opacity={opacity}
								   color={color}/>
				);
			case TextAnnotationIcons.Note:
				return (
					<NoteIcon width={width} height={height} language={this.props.language} opacity={opacity}
							  color={color}/>
				);
			case TextAnnotationIcons.Check:
				return (
					<CheckIcon width={width} height={height} language={this.props.language} opacity={opacity}
							   color={color}/>
				);
			case TextAnnotationIcons.Checkmark:
				return (
					<CheckIcon width={width} height={height} language={this.props.language} opacity={opacity}
							   color={color}/>
				);
			case TextAnnotationIcons.Circle:
				return (
					<CircleIcon width={width} height={height} language={this.props.language} opacity={opacity}
								color={color}/>
				);
			case TextAnnotationIcons.Cross:
				return (
					<CrossIcon width={width} height={height} language={this.props.language} opacity={opacity}
							   color={color}/>
				);
			case TextAnnotationIcons.CrossHair:
				return (
					<CrossHairIcon width={width} height={height} language={this.props.language} opacity={opacity}
								   color={color}/>
				);
			case TextAnnotationIcons.RightArrow:
				return (
					<RightArrowIcon width={width} height={height} language={this.props.language} opacity={opacity}
									color={color}/>
				);
			case TextAnnotationIcons.RightPointer:
				return (
					<RightPointerIcon width={width} height={height} language={this.props.language} opacity={opacity}
									  color={color}/>
				);
			case TextAnnotationIcons.Star:
				return (
					<StarIcon width={width} height={height} language={this.props.language} opacity={opacity}
							  color={color}/>
				);
			case TextAnnotationIcons.UpArrow:
				return (
					<UpArrowIcon width={width} height={height} language={this.props.language} opacity={opacity}
								 color={color}/>
				);
			case TextAnnotationIcons.UpLeftArrow:
				return (
					<UpLeftArrowIcon width={width} height={height} language={this.props.language} opacity={opacity}
									 color={color}/>
				);
			default:
				return (
					<CommentIcon width={width} height={height} language={this.props.language} opacity={opacity}
								 color={color}/>
				);
		}
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 popupContent={annotation.contents} creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				{this.renderIcon()}
			</AnnotationRectangle>
		);
	}
}